import { render, staticRenderFns } from "./WeekNavigator.vue?vue&type=template&id=58d227ac&scoped=true"
import script from "./WeekNavigator.vue?vue&type=script&lang=js"
export * from "./WeekNavigator.vue?vue&type=script&lang=js"
import style0 from "./WeekNavigator.vue?vue&type=style&index=0&id=58d227ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d227ac",
  null
  
)

export default component.exports